<template>
    <div class="user-roles-permissions">
        
         <b-collapse class="card" animation="slide" :open="false">

            <div slot="trigger" slot-scope="props" class="card-header" role="button">
                
                <a class="card-header-icon">
            
                    <i :class="props.open ? `fa fa-chevron-up fa-lg` : `fa fa-chevron-down fa-lg` "></i>
            
                </a> 

                <span class="card-header-icon">
                    <!-- <b-checkbox :value="areAllRolesChecked" @input="toggleAllRoles" @click.native.stop /> -->
                </span>

                <p class="card-header-title">All</p> 
            
                <p class="card-header-icon">{{ checkedPermissions.length }}/{{ allPermissionsDisplay.length }}</p> 
            
                <a class="card-header-icon">
            
                    <i :class="props.open ? `fa fa-chevron-up fa-lg` : `fa fa-chevron-down fa-lg` "></i>
            
                </a>

            </div>

            <div class="card-content">
            
                <div class="content">

                    <p v-if="allPermissionsDisplay.length == 0">No permission</p>

                    <table class="table is-bordered" v-else>
                        <tr>
                            <th width="10">

                                <!-- <b-checkbox v-model="all" @change.native="checkAllPermission" :disabled="!userCanMicroManagePermissions"></b-checkbox> -->
                          
                            </th>
                            <th width="50%">Permission</th>
                            <th>Notes</th>
                        </tr>
                        <tr v-for="permission in allPermissionsDisplay" :key="permission.id">
                            <td width="10">
                                <b-checkbox
                                    :disabled="!userCanMicroManagePermissions"
                                    :native-value="permission.id"
                                    v-model="checkedPermissions"
                                ></b-checkbox>
                            </td>
                            <td>{{ permission.name }}</td>
                            <td>{{ permission.notes }}</td>

                        </tr>
                    </table>

                </div>
            
            </div>

        </b-collapse>


        <b-collapse
            class="card"
            :aria-id="`role-`.index"
            :open="false"
            v-for="(role, index) in filteredRoles"
            :key="index"
        >
            <div
                slot="trigger"
                slot-scope="props"
                class="card-header"
                role="button"
                :aria-controls="`role-`.index"
            >
                <a class="card-header-icon">
                    <i :class="props.open ? `fa fa-chevron-up fa-lg` : `fa fa-chevron-down fa-lg` "></i>
                </a>
                <span class="card-header-icon">
                    <b-checkbox
                        v-model="checkedRoles_"
                        :native-value="role.id"
                        @click.native.stop
                    />
                </span>
                <p class="card-header-title">{{ role.name }}</p>
                <p
                    class="card-header-icon"
                >{{ ishaveValue ? rolePermissionsCheckedCount(role.permissions) : '0' }}/{{ role.permissions.length }}</p>
                <a class="card-header-icon">
                    <i :class="props.open ? `fa fa-chevron-up fa-lg` : `fa fa-chevron-down fa-lg` "></i>
                </a>
            </div>
            <div class="card-content">
                <div class="content">
                    <p v-if="role.permissions.length == 0">No permission</p>
                    <table class="table is-bordered" v-else>
                        <tr>
                            <th width="10">
                                <b-checkbox
                                    v-model="checkedAllPermissionInRoles"
                                    :native-value="role.id"
                                    :disabled="!userCanMicroManagePermissions"
                                    @change.native="checkAll(role)"
                                ></b-checkbox>
                            </th>
                            <th width="50%">Check/Uncheck All</th>
                            <th>Notes</th>
                        </tr>
                        <tr v-for="permission in rolePermissions(role)" :key="permission.id">
                        <!-- <tr v-for="permission in role.permissions" :key="permission.id"> -->
                            <td width="10">
                                <b-checkbox
                                    :disabled="!userCanMicroManagePermissions"
                                    :native-value="permission.id"
                                    v-model="checkedPermissions"
                                ></b-checkbox>
                            </td>
                            <td>{{ permission.name }}</td>
                            <td>{{ permission.notes }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </b-collapse>
    </div>
</template>
<script>
import { RoleService } from "@/services/role.service";
import { PermissionService } from "@/services/permission.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import { systemTagMixin } from '@/mixins/systemTagMixin';
export default {
    props: {
        checked: {
            type: Array,
            default: () => []
        },
        checkedRoles: {
            type: Array,
            default: () => []
        },
        ishaveValue: {
            type: Boolean,
            default: () => false
        },
        defaultRole: {
            type: Array,
            default: () => []
        },
        organization: {
            type: Object,
            default: () => {}
        }
    },
    data: () => ({
        roleService: RoleService,

        // permissions: [],
        
        roles: [],
        
        checkedPermissions: [],

        checkedRoles_: [],

        all: false,

        uncheck: [],

        allPermissions: [],

        checkedAllPermissionInRoles: [],
        allRoles: [],
        nativeData: [],

    }),
    watch: {
        checked(checked) {
            this.checkedAllPermissionInRoles = [];
            this.checkedPermissions = checked;
            this.roles.forEach(role => {
                const checkedCount = this.rolePermissionsCheckedCount(
                    role.permissions
                );
                if (checkedCount == role.permissions.length) {
                    this.checkedAllPermissionInRoles.push(role.id);
                }
            });
        },
        checkedPermissions(checked) {
            
            this.$emit("update:checked", checked);

        },
        checkedRoles(roles) {
            this.checkedRoles_ = roles;
        },
        checkedRoles_(roles, old_roles) {
            if (this.userCanOnlyToggleRoles) {
                let prev = old_roles || [];
                let permissions_added_via_role = [];
                let permissions_removed_via_role = [];
                let roles_added = _.difference(roles, prev);
                let roles_removed = _.difference(prev, roles);
                roles_added.forEach(role_id => {
                    const role = this.roles.find(r => r.id == role_id);
                    const role_permissions = role ? role.permissions : []; // in case user has some hidden role
                    const role_permission_ids = role_permissions.map(p => p.id);
                    const permissions_added = _.difference(role_permission_ids, this.checkedPermissions);
                    permissions_added_via_role = permissions_added_via_role.concat(permissions_added);
                });
                roles_removed.forEach(role_id => {
                    const role = this.roles.find(r => r.id == role_id);
                    if ( ! role) {
                        // Avoid errors when legacy/unrecognised role_id is removed
                        return;
                    }
                    const role_permission_ids = role.permissions.map(p => p.id);
                    const permissions_removed = _.intersection(role_permission_ids, this.checkedPermissions);
                    permissions_removed_via_role = permissions_removed_via_role.concat(permissions_removed);
                });
                // For removed roles, if the user will still have another role that would grant them one
                // or more of the permissions from the removed roles, the user keeps those permissions.
                // NOTE: just because the target user has a role, doesn't mean that they have all of
                // the role's permissions. Some users can assign roles separately from permissions.
                // So we'll only keep the permission if the user has another role containing the
                // permission, and already has the permission itself.
                let sticky_permission_ids = [];
                // Disabled as this level of complexity not required.
                /*
                roles.forEach(role_id => {
                    // Reminder: this.checkedRoles is the roles currently assigned to the user
                    // and doesn't represent state of role checkboxes (which just changed).
                    if (this.checkedRoles.includes(role_id)) {
                        const role = this.roles.find(r => r.id == role_id);
                        const role_permissions = role ? role.permissions : []; // in case user has some hidden role
                        let permission_ids = role_permissions.map(p => p.id);
                        permission_ids = _.intersection(permission_ids, this.checked);
                        sticky_permission_ids = sticky_permission_ids.concat(permission_ids);
                    }
                });
                */
                permissions_added_via_role = _.uniq(permissions_added_via_role);
                permissions_removed_via_role = _.uniq(permissions_removed_via_role);
                sticky_permission_ids = _.uniq(sticky_permission_ids);
                permissions_removed_via_role = _.difference(permissions_removed_via_role, sticky_permission_ids);
                let permissions_next = this.checkedPermissions.concat(permissions_added_via_role);
                permissions_next = _.difference(permissions_next, permissions_removed_via_role);
                this.checkedPermissions = permissions_next;
            }
            this.$emit("update:checkedRoles", roles)
        },

        allPermissions() {

            let checked = this.checkedPermissions.length;

            let allPermissions = this.allPermissions.length;

            this.all = checked == allPermissions;
        },

        // defaultRole(value) {

        //     this.checkedRoles = [];

        //     let 
        //     value.forEach((v, k) => {
        //         let role = this.filteredRoles.find(element => element.id == v);
        //         console.log(role);
        //         this.checkedRoles.push(v);
        //     });

        // }

        // 'defaultRole.general'(value) {
            
        //     let general = this.roles.find(element => element.name.toLowerCase() == 'superadmin' );

        //     if (value) {

        //         if (!this.checkedRoles.find(element => element == general.id)) {
               
        //             this.checkedRoles.push(general.id);
               
        //         }

        //         general.permissions.forEach(permission => {

        //             if (!this.checked.find(element => element == permission.id)) {
                        
        //                 this.checked.push(permission.id);

        //             }

        //         });


        //     }else {

        //         this.checkedRoles.splice(this.checkedRoles.findIndex(element => element == general.id), 1)

        //         general.permissions.forEach(permission => {

        //             this.checked.splice(this.checked.findIndex(element => element == permission.id), 1)
                
        //         });

        //     }

        // },

        // 'defaultRole.admin'(value) {
            
        //     let admin = this.roles.find(element => element.name.toLowerCase() == 'admin' );

        //     if (value) {

        //         if (!this.checkedRoles.find(element => element == admin.id)) {
               
        //             this.checkedRoles.push(admin.id);
               
        //         }

        //         admin.permissions.forEach(permission => {

        //             if (!this.checked.find(element => element == permission.id)) {
                        
        //                 this.checked.push(permission.id);

        //             }

        //         });


        //     }else {

        //         this.checkedRoles.splice(this.checkedRoles.findIndex(element => element == admin.id), 1)

        //         admin.permissions.forEach(permission => {

        //             this.checked.splice(this.checked.findIndex(element => element == permission.id), 1)
                
        //         });

        //     }

        // }


    },
    methods: {
        async fetchRoles() {
            const params = { type: 'person', includes: "permissions,tags" };
            const response = await this.roleService.all(params);
            let tempRole = JsonDenormalizer.denormalize(response);
            this.roles = JsonDenormalizer.denormalize(response);
            // this.allRoles = tempRole;
            // if (!this.isSuperAdmin) {
            //     tempRole = tempRole.filter(element => element.name.toLowerCase() != 'superadmin');
            // }

            // if (this.isSuperAdmin) {
            //     this.roles =  tempRole.filter(element => {
            //         if (element.type) {
            //             return element.type.toUpperCase().includes('[SYSTEM][ROLE]');
            //         }   
            //         return false;
            //     });
            // } else {
            //     let roles = tempRole.filter(element => {
            //         if (element.name.toUpperCase() == 'SUPERADMIN') {
            //             return false;
            //         }
            //         let managed = element.managed_by_firm_id == this.organization.id;
            //         let tag = false;
            //         if (element.tags.length) {
            //             tag = element.tags.find(tag => tag.type.toUpperCase() == '[SYSTEM]');
            //         } 
            //         return managed || tag;
            //     });
            //     this.roles = roles.filter(element => element.type.toUpperCase().includes('[SYSTEM][ROLE]'));
            // }


            // this.roles = tempRole;
        },
        rolePermissionsCheckedCount(permissions) {
            const count = permissions.filter(permission => {
                return this.checkedPermissions.includes(permission.id);
            }).length;
            return count;
        },
        toggleAllRoles(value) {
            if (value) {
                this.checkedRoles_ = this.filteredRoles.map(role => role.id);
                // this.checkedRoles_ = this.roles.map(role => role.id);
            } else {
                this.checkedRoles_ = [];
            }
        },
        checkAll(role) {

            if (this.checkedAllPermissionInRoles.includes(role.id)) {
                
                role.permissions.forEach(permission => {

                    const index = this.checkedPermissions.indexOf( permission.id );

                    if (index == -1) {
                        
                        this.checkedPermissions.push(permission.id);

                    }
                
                });

            } else {
                role.permissions.forEach(permission => {

                    const index = this.checkedPermissions.indexOf(
                        permission.id
                    );
                    
                    // if (index > -1) {
                        this.checkedPermissions.splice(index, 1);
                    // }
                    
                });
            }
        },

        checkAllPermission() {

            this.checkedPermissions = [];

            if (this.all) {

                this.allPermissionsDisplay.forEach(permission => {

                    this.checkedPermissions.push(permission.id);
                
                });

            }     

        },

        rolePermissions(role) {
            let permissions = [];
            role.permissions.forEach(x => {
                if (! permissions.find(permission => x.name == permission.name)) {
                    if (!this.systemPermissions.find(exclude => exclude == x.id)) {
                        permissions.push(x);
                    }
                }
            });
            return permissions.sort((a, b) => {
                var x = a.name.toLowerCase(), y = b.name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
            });

        },

        async getTags() {
            await PermissionService.getTags().then(response => {
                this.nativeData = response;
            });
        },

        async getAllPermissions() {
            await PermissionService.all({type:'user'}).then(response => {
                this.allPermissions = JsonDenormalizer.denormalize(response);
            });
            // RoleService.getPermissions({superadmin: this.isSuperAdmin}).then(response => {
            //     console.log(response);
            // });
        }

    },

    computed: {
        userCanMicroManagePermissions() {
            return (this.$store.getters['Auth/hasPermission']('can manage user permissions'));
        },
        userCanOnlyToggleRoles() {
            return (this.$store.getters['Auth/hasPermission']('can manage users')
                && ! this.userCanMicroManagePermissions);
        },
        filteredRoles() {

            
            // if (this.isSuperAdmin) {
                // return this.roles.filter(element => {
                //     if (element.type) {
                //         return element.type.toUpperCase().includes('[SYSTEM][ROLE]');
                //     }   
                //     return false;
                // });
            // } else {
                let roles = this.roles.filter(element => {
                    if (element.name.toUpperCase() == 'SUPERADMIN' && !this.isSuperAdmin) {
                        return false;
                    }
                    let managed = false;
                    if (this.organization.managed_by) {
                        managed = element.managed_by_firm_id == this.organization.managed_by;
                    } else {
                        managed = element.managed_by_firm_id == this.organization.id;
                    }
                    let tag = false;
                    if (element.tags.length) {
                        tag = element.tags.find(tag => tag.type.toUpperCase() == '[SYSTEM]');
                    } 
                    return managed || tag;
                });
                // return roles.filter(element => element.type.toUpperCase().includes('[SYSTEM][ROLE]'));
                roles = roles.filter(element => {
                    return element.type && element.type.toUpperCase().includes('[SYSTEM][ROLE]')
                });

                roles = roles.filter(r => {
                    return ( ! r.archived_at);
                });

                return _.sortBy(roles, r => {
                    return r.name.toLowerCase();
                });
            // }


        },
        systemPermissions() {
            let systemPermission = this.nativeData.filter(element => element.tags.length && element.tags[0].pivot.archived_at == null);
            if (systemPermission.length) {
                return systemPermission.map(element => element.id);
            }
            return [];
        },
        areAllRolesChecked() {
            const roleIds = this.roles.map(role => role.id);
            return roleIds.every(roleId => this.checkedRoles_.includes(roleId));
        },
        isSuperAdmin() {
          return this.$store.getters["Auth/hasRole"]('superadmin');
        },
        allPermissionsDisplay() {
            // if (!this.isSuperAdmin && this.roles.length && this.allPermissions.length) {
            //     let superadmin = this.allRoles.find(element => element.name.toLowerCase() == 'superadmin').permissions
            //     console.log(superadmin);
            //     return this.allPermissions.filter(element => {
            //         return ! superadmin.find(x => x.name == element.name);
            //     });
            // }
            if (!this.isSuperAdmin) {
                let systemPermission = this.nativeData.filter(element => element.tags.length && element.tags[0].pivot.archived_at == null);
                if (systemPermission.length) {
                    let excludePermissions = systemPermission.map(element => element.id);
                    return this.allPermissions.filter(element => {
                        return !excludePermissions.find(exclude => exclude == element.id);
                    });
                }
            }

            return this.allPermissions;
        },

        // allPermissions() {

        //     let permissions = [];

        //     this.roles.forEach(role => {

        //         role.permissions.forEach(x => {

        //             if (permissions.find(permission => x.name == permission.name)) {

                
        //             }else{
                        
        //                 permissions.push(x);

        //             }

        //         })

        //     });

        //     return permissions.sort((a, b) => {

        //         var x = a.name.toLowerCase(), y = b.name.toLowerCase();
    
        //         return x < y ? -1 : x > y ? 1 : 0;

        //     });

        // }

    },

    mounted() {
        this.getTags();
        this.fetchRoles();
        this.getAllPermissions();
        
        // this.checkedPermissions = this.checked;

        // console.log(this.checked);

        this.checkedRoles_ = this.checkedRoles;
        this.checkedPermissions = this.checked;

        // alert();
    },


};
</script>

<style scoped>
.permissions {
    margin-top: -5px;
    margin-right: 0;
}
.permission {
    padding: 5px 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Organization/persons/rolesAndPermissions.vue